import { createUseStyles } from "react-jss";
import { ITheme } from "../../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    paddingTop: 80,
    padding: theme.spacing.space16,
  },
  content: {
    display: "flex",
    width: "100vw",
    alignItems: "center",
    gap: theme.spacing.space16,
  },
  buttons: {
    display: "flex",
    gap: theme.spacing.space16,
    paddingTop: theme.spacing.space16,
    paddingBottom: theme.spacing.space16,
  },
  line: {
    width: "-webkit-fill-available",
    height: 1,
    background: "linear-gradient(90deg, #000 0%, #D9D9D9 50.5%, #000 100%)",
    margin: theme.spacing.space16,
    display: "flex",
  },
}));
